import {border, textDecoration} from '@chakra-ui/react'
import {fonts} from '../../../theme/foundations/fonts'
import {pxToRem} from '../../../utills/pxToRem'

export const contactInfoFormStyles = {
    label: {
        fontWeight: 400,
        letterSpacing: pxToRem(1),
        marginTop: pxToRem(23)
    }
}

export const editEmailWrapper = {
    display: 'flex',
    alignItems: 'baseline'
}

export const editEmailMainLabel = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1), pxToRem(1), pxToRem(1.28), pxToRem(1.28)],
    marginBottom: pxToRem(15)
}

export const editEmailLabel = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
    fontWeight: 400,
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    marginBottom: 0
}

export const contactInfoSummaryEmailPhoneWrapper = {
    display: ['block', 'block', 'flex', 'flex'],
    columnGap: [pxToRem(20), pxToRem(20), pxToRem(45), pxToRem(45)],
    rowGap: [pxToRem(20), pxToRem(20), pxToRem(45), pxToRem(45)],
    marginTop: pxToRem(1)
}

export const summaryEmailMainLabel = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: [pxToRem(1), pxToRem(1), pxToRem(1.28), pxToRem(1.28)],
    marginBottom: pxToRem(10)
}

export const summaryEmailLabel = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)],
    fontWeight: 400,
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    marginBottom: 0
}

export const errorText = {
    color: 'cav_error_red',
    display: 'inline',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
    fontWeight: 400,
    fontStyle: 'italic',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    marginTop: [pxToRem(5), pxToRem(5), pxToRem(10), pxToRem(10)]
}

export const forgotPasswordButton = {
    ...errorText,
    color: 'black',
    textDecoration: 'underline',
    marginTop: [pxToRem(5), pxToRem(5), pxToRem(10), pxToRem(10)],
    '&:hover': {
        textDecoration: 'none'
    }
}

export const editEmailButton = {
    color: 'cav_red',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(10), pxToRem(10), pxToRem(12), pxToRem(12)],
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    textTransform: 'uppercase',
    marginLeft: pxToRem(15)
}
export const filledButton = {
    height: [pxToRem(35), pxToRem(35), pxToRem(40), pxToRem(40)],
    paddingTop: [pxToRem(12)],
    paddingBottom: [pxToRem(12)],
    paddingLeft: [pxToRem(20)],
    paddingRight: [pxToRem(20)],
    color: 'white',
    backgroundColor: 'cav_red',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(14), pxToRem(14)],
    fontWeight: 700,
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    borderRadius: 0,
    '&:hover': {
        color: 'cav_red',
        backgroundColor: 'white',
        borderColor: 'cav_red',
        border: '1px solid'
    },
    '&:disabled': {
        backgroundColor: 'cav_red',
        '&:hover': {
            color: 'white',
            backgroundColor: 'cav_red'
        }
    }
}

export const outlineButton = {
    ...filledButton,
    color: 'cav_red',
    backgroundColor: 'white',
    bordeer: `${pxToRem(1)} solid`,
    borderColor: 'cav_red',
    '&:hover': {
        color: 'white',
        backgroundColor: 'cav_red'
    },
    '&:disabled': {
        backgroundColor: 'white',
        '&:hover': {
            color: 'white',
            backgroundColor: 'white'
        }
    }
}
